import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-shell-header',
  templateUrl: './shell-header.component.html',
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        background: theme('colors.sky.black');
        color: theme('colors.white');
        padding: theme('padding.6') theme('padding.8');
      }
    `,
  ],
})
export class ShellHeaderComponent {
  @Input() public mobileNav$!: BehaviorSubject<{ expand: boolean }>;
  @Output() public toggleNav = new EventEmitter<boolean>();

  public isNavOpened = false;
  public isMobileView$ = this._appService.isMobileView$;

  constructor(private readonly _appService: AppService) {}

  public toggle() {
    this.mobileNav$.next({ expand: !this.mobileNav$.getValue().expand });

    // this.toggleNav.emit(this.isNavOpened);
  }
}
